import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal } from "risa-oasis-ui_v2";
import { prepareFormQuestionnaire } from "../../../api/postCall/prepareForm";
import { usePayerNameContextFromSingleOrderLayout } from "../../../context/payerNameContextFromSingleOrderLayout";
import { ScreenNamesForBigQuery } from "../../../enums/eventsData";
import { EventsName } from "../../../enums/eventsName";
import { ModalId } from "../../../enums/modalId";
import { fetchSingleMedicalPaFormConfig } from "../../../redux/slice/medicalPa/singleMedicalPaFormConfig";
import { closeModal } from "../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../redux/store/store";
import ChevronDown from "../../../svg/chevron-down";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";
import ErrorState from "./errorState";
import { useGetFormName } from "./hooks/useGetFormName";
import LoadingState from "./loadingState";
import { computeStylesForSelectedId } from "./utils/computeStylesForSelectedId";

import { apiWorkerManager } from "../../../workerManagers/workerManager";
const FormSelectionModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const { metaData } = useSelector((state: RootState) => state.modal);
  const { formNameState } = useGetFormName(
    metaData?.orderId ?? "",
    metaData?.payerName ?? "",
  );
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const [formConfigs, setFormConfigs] = useState<
    {
      id: string;
      name: string;
    }[]
  >([]);
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );
  const { payerName } = usePayerNameContextFromSingleOrderLayout();
  const orgId = getOrgIdForFetchExternalWorklist();

  useEffect(() => {
    if (metaData) {
      setFormConfigs(metaData.formConfigs);
    }
  }, [metaData]);

  const handleClick = async (formConfig: { id: string; name: string }) => {
    dispatch(fetchSingleMedicalPaFormConfig(formConfig.id ?? ""));
    prepareFormQuestionnaire({
      formId: formConfig.id ?? "",
      orderId: singleMedicalPaOrder?.order_id ?? "",
    });
    apiWorkerManager.enqueueAndProcess({
      patient_id: singleMedicalPaOrder?.patient_id ?? "",
      order_id: singleMedicalPaOrder?.order_id ?? "",
      org_id: orgId ?? "",
      event_name: EventsName.FORM_SELECTED + " (" + formConfig.name + ")",
      user_id: user?.id ?? "",
      user_email: user?.email ?? "",
      additional_data: {
        screen_name: ScreenNamesForBigQuery.AUTH_STATUS_SCREEN,
        source: ScreenNamesForBigQuery.AUTH_STATUS_SCREEN,
        patient_mrn: singleMedicalPaOrder?.payload?.patient_id ?? "",
        value: formConfig.name,
        payer_name: payerName,
        recommended_form_name: formNameState?.data?.form_name ?? "",
      },
    });
    dispatch(closeModal());
    navigate(`/worklists/medical-pa-form/${singleMedicalPaOrder?.id ?? ""}`);
  };

  return (
    <Modal
      dialogId={ModalId.FORM_SELECTION_MODAL}
      onSave={function (): void | Promise<void> {
        throw new Error("Function not implemented.");
      }}
      title={"Form Selection"}
      saveButtonText={""}
      cancelText={""}
      onClose={() => {
        dispatch(closeModal());
      }}
      onCancel={() => {
        dispatch(closeModal());
      }}
      hideFooter={true}
    >
      <div className="form-selection--container flex flex-col gap-4 pb-4">
        {formNameState.loading ? (
          <LoadingState />
        ) : formNameState.error ? (
          <ErrorState error={formNameState.error} />
        ) : (
          <>
            <div className="form-selection--header text-body font-semibold">
              Select the form you want to proceed with
            </div>
            {formConfigs.map((formConfig) => (
              <div
                className="single-form--card flex w-full cursor-pointer items-center gap-2 rounded border border-primaryGray-14 p-3 hover:bg-primaryGray-16"
                id={formConfig.id}
                key={formConfig.id}
                style={
                  formConfig?.id === formNameState?.data?.form_name
                    ? computeStylesForSelectedId()
                    : {}
                }
                onClick={() => handleClick(formConfig)}
              >
                <div className="form-title flex-1 truncate text-small">
                  {formConfig.name}
                </div>
                <div className="form-icon">
                  <ChevronDown rotate={-90} height={20} width={20} />
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </Modal>
  );
};

export default FormSelectionModal;
